import WistiaHelper from '../gdpr/wistia-helper';
import merge from 'lodash.merge';
import WG from '../modules/wg';

(function(global) {
    function Intro() {
        this.$modalVideo = $('#modalVideo');
        this.$socialLink = $('.social__link');
        this.wistiaId = this.$modalVideo.data('wistia-id');
        this.youtubeId = this.$modalVideo.data('youtube-id');

        this.init();
    }

    Intro.prototype.init = function() {
        this.$modalVideo.on(
            'show.wg.modal',
            function() {
                WG.GdprUserCentrics.makeConditionalCallback(() => {
                    if (this.wistiaId) {
                        WistiaHelper.appendWistiaVideo(this.$modalVideo, this.wistiaId, '', '');
                    } else if (this.youtubeId) {
                        this.$modalVideo.append(
                            '<iframe src="https://www.youtube.com/embed/' +
                                this.youtubeId +
                                '/?autoplay=true" frameborder="0" allowfullscreen></iframe>'
                        );
                    }
                }, WG.GdprUserCentrics.ConsentCategories.Advertising)();
            }.bind(this)
        );

        this.$modalVideo.on(
            'hide.wg.modal',
            function() {
                this.$modalVideo.children(':not(.modal-video__close)').detach();
            }.bind(this)
        );

        this.initRegistration();
        this.initAirPrTracking();
        this.initSocialModal();
    };

    Intro.prototype.initRegistration = function() {
        var Registration = new WG.RegistrationNew();

        Registration.setOptions({
            forms: $('.subtitle-form')
        });
        Registration.init();
    };

    Intro.prototype.initSocialModal = function() {
        var socialModalWidth = 600;
        var socialModalHeight = 700;

        if (!this.$socialLink.length) {
            return false;
        }

        this.$socialLink.on('click', function(event) {
            event.preventDefault();
            global.openCenterWindow($(this).attr('href'), 'socialShareModal', socialModalWidth, socialModalHeight);
        });
    };

    Intro.prototype.initAirPrTracking = function() {
        const $trialForm = $('.section-intro .wg-form');

        $trialForm.on('success.wg.registration', function() {
            const addons = $trialForm.data('addons');
            const packages = $trialForm.data('packages');
            const onboarding = $trialForm.data('onboarding');

            const defaultData = {
                value: {
                    email: $(this)
                        .find('.global-form__input')
                        .val(),
                    form: $(this).data('hash'),
                    plan: $trialForm.data('plan') || 'BIZ_2021',
                    addons,
                    packages,
                    onboarding,
                    c_email: window.wrike.cEmail || 'null',
                    existing_user: window.wrike.isUserExisting
                }
            };

            const statSiteData = {
                group: 'trial_forms',
                event: 'trial_form__submit',
                path: window.location.pathname
            };

            const airPrData = {
                event: 'trial_form__submitted'
            };

            global.trackEventForm(merge(defaultData, statSiteData));
            new WG.AirPrTracking(merge(defaultData, airPrData));
        });

        $trialForm.on('user.exist.wg.success.registration', function() {
            const addons = $trialForm.data('addons');
            const packages = $trialForm.data('packages');
            const onboarding = $trialForm.data('onboarding');

            const defaultData = {
                value: {
                    email: $(this)
                        .find('.global-form__input')
                        .val(),
                    form: $(this).data('hash'),
                    plan: $trialForm.data('plan') || 'BIZ_2021',
                    addons,
                    packages,
                    onboarding,
                    c_email: window.wrike.cEmail || 'null',
                    existing_user: window.wrike.isUserExisting
                }
            };

            const statSiteDataForExistedUser = {
                group: 'exist_user_form_submit',
                event: 'exist_trial_form__submit',
                path: window.location.pathname
            };

            const airPrDataForExistedUser = {
                event: 'exist_trial_form__submitted'
            };

            global.trackEventForm(merge(defaultData, statSiteDataForExistedUser));
            new WG.AirPrTracking(merge(defaultData, airPrDataForExistedUser));
        });
    };

    global.widgets = global.widgets || {};
    global.widgets.Intro = Intro;
})(window.wrike);



// WEBPACK FOOTER //
// ./assets/js/common/widgets/wrike-intro.js